import List from './list/ContactList';

export default { List }